import { styled, Currency, SvgIcon } from '@teko/ui';
import React from 'react';
import { space } from 'styled-system';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = styled.div(space, ({ theme }) => `
  display: flex;
  justify-content: space-between;
  --button-icon-color: ${theme == null ? void 0 : theme.colors.green400};
  `);
const PriceWrapper = styled.div`
  display: flex;
  flex-direction: ${(props) => props.horizontal ? "" : "column"};
  align-items: baseline;
`;
const Price = styled(Currency)((props) => {
  var _a, _b;
  return `
  margin-bottom: ${props.size === "lg" ? "0.5rem" : "0"};
  font-size: ${props.size === "md" ? "1rem" : "1.75rem"};
  font-weight: 500;
  color: ${(_b = (_a = props.theme) == null ? void 0 : _a.brand) == null ? void 0 : _b.primary};
  font-weight: bold;
`;
});
const DiscountWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;
const ListedPrice = styled(Currency)(({ lineThrough, theme, size, horizontal }) => `
  text-decoration: ${lineThrough ? "line-through" : "none"};
  color: ${theme.colors.gray130};
  font-size: ${size === "md" ? "0.75rem" : "1.25rem"};
  margin-left: ${horizontal ? "6px" : ""};
`);
const Discount = styled.span(({ theme }) => {
  var _a;
  return `
  font-size: 0.75rem;
  color: ${(_a = theme == null ? void 0 : theme.brand) == null ? void 0 : _a.secondary};
  margin-left: 6px;
`;
});
const EditIcon = styled(SvgIcon)(({ theme }) => `
    width: 1.25rem;
    height: 1.25rem;
    margin-left: 0.25rem;
    background-color: ${theme == null ? void 0 : theme.colors.link500};
  `);
const PriceEditIcon = styled.div`
  display: flex;
  flex-direction: row;
`;
const ProductPrice = (_a) => {
  var _b = _a, {
    price,
    discount,
    horizontal = false,
    size = "md",
    className,
    unitPrice,
    listedPrice,
    consultationServiceFee = 0,
    isPriceEditable = false,
    onEditPrice
  } = _b, props = __objRest(_b, [
    "price",
    "discount",
    "horizontal",
    "size",
    "className",
    "unitPrice",
    "listedPrice",
    "consultationServiceFee",
    "isPriceEditable",
    "onEditPrice"
  ]);
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    className
  }), /* @__PURE__ */ React.createElement(PriceWrapper, {
    horizontal
  }, price !== null && price !== void 0 && /* @__PURE__ */ React.createElement(PriceEditIcon, null, /* @__PURE__ */ React.createElement(Price, {
    className: "price",
    size,
    value: price
  }), isPriceEditable && /* @__PURE__ */ React.createElement(EditIcon, {
    name: "edit",
    onClick: onEditPrice
  })), /* @__PURE__ */ React.createElement(DiscountWrapper, null, unitPrice && unitPrice !== price - consultationServiceFee && /* @__PURE__ */ React.createElement(ListedPrice, {
    className: "listed-price",
    horizontal,
    size,
    value: unitPrice,
    lineThrough: true
  }), !!listedPrice && listedPrice !== price && /* @__PURE__ */ React.createElement(ListedPrice, {
    className: "listed-price",
    horizontal,
    size,
    value: listedPrice,
    lineThrough: !!listedPrice && listedPrice !== price
  }), !!discount && /* @__PURE__ */ React.createElement(Discount, {
    className: "discount"
  }, discount))));
};

export { ProductPrice };
